import { render, staticRenderFns } from "./HeaderCard.vue?vue&type=template&id=805aead8&scoped=true"
import script from "./HeaderCard.vue?vue&type=script&lang=js"
export * from "./HeaderCard.vue?vue&type=script&lang=js"
import style0 from "./HeaderCard.vue?vue&type=style&index=0&id=805aead8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805aead8",
  null
  
)

export default component.exports